import { ActionType } from '../constants/ActionTypes'
export default function tournamentsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_TOURNAMENTS_BEGIN:
            return {
                ...state,
                isLoading: true,
                isMoreLoading: false,
                tournamentsList: []
            }
        case ActionType.GET_TOURNAMENTS_AND_KEEP_OLD_BEGIN:
            return {
                ...state,
                isMoreLoading: true
            }
        case ActionType.GET_TOURNAMENTS_ERROR:
            return {
                ...state,
                isLoading: false,
                isMoreLoading: false,
                error: action.payload,
            }
        case ActionType.GET_TOURNAMENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tournamentsList: action.payload
            }
        case ActionType.GET_TOURNAMENTS_AND_KEEP_OLD_SUCCESS:
            return {
                ...state,
                isMoreLoading: false,
                tournamentsList: {
                    hasNext: action.payload.hasNext,
                    tournaments: [...state.tournamentsList.tournaments, ...action.payload.tournaments]
                }
            }
        case ActionType.GET_TOURNAMENT_GAMES_BEGIN:
            return {
                ...state,
                isGamesLoading: true
            }
        case ActionType.GET_TOURNAMENT_GAMES_ERROR:
            return {
                ...state,
                isGamesLoading: false,
                error: action.payload,
            }
        case ActionType.GET_TOURNAMENT_GAMES_SUCCESS:
            return {
                ...state,
                isGamesLoading: false,
                gamesObj: {
                    hasNext: action.payload.hasNext,
                    games: [...state.gamesObj.games, ...action.payload.games]
                }
            }
        case ActionType.GET_TOURNAMENT_BEGIN:
            return {
                ...state,
                isLoading: true,
                tournament: {},
                gamesObj: {
                    games: [],
                    hasNext: false
                }
            }
        case ActionType.GET_TOURNAMENT_ERROR:
            return {
                ...state,
                isLoading: false,
                gamesObj: null,
                error: action.payload,
            }
        case ActionType.GET_TOURNAMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tournament: action.payload
            }
        case ActionType.JOIN_TOURNAMENT_BEGIN:
            return {
                ...state,
                isSaving: action.payload
            }
        case ActionType.JOIN_TOURNAMENT_ERROR:
            return {
                ...state,
                isSaving: false
            }
        case ActionType.JOIN_TOURNAMENT_SUCCESS:
            return {
                ...state,
                isSaving: false,
                tournament: {
                    ...state.tournament,
                    isJoined: true
                },
            }
        case ActionType.JOIN_TOURNAMENT_IN_LIST_SUCCESS:
            return {
                ...state,
                isSaving: false,
                tournamentsList: {
                    hasNext: state.tournamentsList.hasNext,
                    tournaments: state.tournamentsList.tournaments.map(tournament => { return tournament.id === action.payload ? { ...tournament, isJoined: true } : tournament })
                }
            }
        default:
            return state;
    }

}

